// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emoji-box[data-v-a07791cc] {\r\n  background: #fff;\r\n  height: 150px;\r\n  width: 300px;\r\n  overflow: auto;\r\n  text-align: left;\n}\n.emoji-box ul[data-v-a07791cc] {\r\n  padding: 0;\n}\n.emoji-box li[data-v-a07791cc] {\r\n  display: inline-block;\r\n  width: 28px;\r\n  height: 28px;\r\n  line-height: 28px;\r\n  text-align: center;\r\n  cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
